module.exports = __webpack_public_path__ + "static/media/objects2_25.cf569cee.svg";